import React from 'react';
import './styles.scss';
 
// Define the props interface
interface CardProps {
  title: string;
  url: string;
  onClick: (url: string) => void;
  style?: React.CSSProperties;
}
 
// Functional component with type annotations
const Card: React.FC<CardProps> = ({ title, url, onClick, style }) => {
  return (
    <div onClick={() => onClick(url)} className='product' style={style}>
      <h3 className='product-title'>{title}</h3>
    </div>
  );
};
 
export default Card;